module.exports = __webpack_public_path__ + "img/tablist-ico01-active.13251ff8.png";